module.exports = __webpack_public_path__ + "img/close.321e8e59.png";